import * as settings from '../actions/settings';
import { COLOR_NAVY, COLOR_WHITE } from 'utils/constants';

const initialState = {
  isFetching: true,
  logoUrl: '',
  iconUrl: '',
  faviconUrl: '',
  siteTitle: '',
  showSignupPage: false,
  showAccountsPage: false,
  showPaymentPage: false,
  styles: {
    topBarBackgroundColor: COLOR_WHITE,
    sideBarBackgroundColor: COLOR_NAVY,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case settings.GET_SITE_SETTINGS_REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case settings.GET_SITE_SETTINGS_SUCCESS:
      return {
        isFetching: false,
        logoUrl: action.payload.logo_url,
        iconUrl: action.payload.icon_url,
        faviconUrl: action.payload.favicon_url,
        siteTitle: action.payload.site_title,
        showSignupPage: action.payload.show_signup,
        showAccountsPage: action.payload.show_accounts,
        showPaymentPage: action.payload.show_payment,
        styles: {
          ...state.styles,
          ...JSON.parse(action.payload.styles),
        },
      };

    case settings.GET_SITE_SETTINGS_FAILURE:
      return {
        ...initialState,
        isFetching: false,
      };

    case settings.UPDATE_SIDEBAR_COLOR:
      return {
        ...state,
        styles: {
          ...state.styles,
          sideBarBackgroundColor: action.payload,
        },
      };

    case settings.UPDATE_TOPBAR_COLOR:
      return {
        ...state,
        styles: {
          ...state.styles,
          topBarBackgroundColor: action.payload,
        },
      };

    default:
      return state;
  }
};
